import { useEffect, useRef, useState } from "react";
import { theme } from "../../theme";

import "./styles.css";

const EmptyFile = ({stepFlowIsEnable}) => {
    if(stepFlowIsEnable) {
        return <i className="material-symbols-rounded opacity-4" style={{fontSize: '100px'}}>image</i>
    }

    return <p style={{paddingTop: '25px'}}>Drag & drop files here, or click to select files</p>;
};

const FileUpload = ({files, setFiles, stepFlowIsEnable, deleteJobImage}) => {
    const fileInputRef = useRef(null);

    const handleDrop = (event) => {
        event.preventDefault();
        addFiles(event.dataTransfer.files);
    };

    const handleFileInput = (event) => {
        addFiles(event.target.files);
    };

    const addFiles = (fileList) => {
        const newFiles = Array.from(fileList).map((file) => ({
            file,
            preview: isImageFile(file) ? URL.createObjectURL(file) : null,
            isExisting: false
        }));
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const isImageFile = (file) => file.type.startsWith("image/");

    const removeFile = async (index, event) => {
        event.stopPropagation();

        const file = files[index];
        if(file.isExisting){
            await deleteJobImage(file.id);
        }

        if (file.preview) {
            URL.revokeObjectURL(file.preview);
        }
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const preventDefaults = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleClick = () => fileInputRef.current.click();

    useEffect(() => {
        return () => {
            files.forEach((fileObj) => {
                if (fileObj.preview) {
                    URL.revokeObjectURL(fileObj.preview);
                }
            });
        };
    }, [files]);

    return (
        <div>
            <div
                className={stepFlowIsEnable ? "upload-area-step-flow" : "upload-area"}
                onDragEnter={preventDefaults}
                onDragOver={preventDefaults}
                onDrop={handleDrop}
                onClick={handleClick}
            >
                {!files.length && <EmptyFile stepFlowIsEnable={stepFlowIsEnable} />}
                <input
                    type="file"
                    multiple
                    onChange={handleFileInput}
                    style={{ display: "none" }}
                    ref={fileInputRef}
                />

                <div className={stepFlowIsEnable ? "file-previews-step-flow" : "file-previews"}>
                    {files.map((fileObj, index) => (
                        <div key={index} className={stepFlowIsEnable ? 'file-item-step-flow' : 'file-item'}>
                            {fileObj.preview ? (
                                <img
                                    src={fileObj.preview}
                                    alt={`Preview ${index}`}
                                    className="file-preview"
                                />
                            ) : (
                                <div
                                    className="file-icon"
                                    title={fileObj.file.name}
                                >
                                    <i className="material-symbols-rounded" style={{fontSize: '50px'}}>description</i>
                                </div>
                            )}
                            <button
                                onClick={(event) => removeFile(index, event)}
                                className="remove-button"
                            >
                                <i className="material-symbols-rounded">close</i>
                            </button>
                        </div>
                    ))}

                    {(files.length > 0 && !stepFlowIsEnable) && (
                        <div className="add-more-box" onClick={handleClick}>+</div>
                    )}
                </div>

                {stepFlowIsEnable && (
                    <button className={`btn btn-sm btn-icon btn-3 btn-outline-${theme.main} w-100 mt-3`} type="button" onClick={handleClick}>
                        <span className="btn-inner--icon"><i className="material-symbols-rounded text-md">attach_file</i></span>
                        <span className="btn-inner--text">Upload from desktop</span>
                    </button>
                )}
            </div>
        </div>
    );
};

const FileUploadWrapper = (stepFlowIsEnable = false, deleteJobImage = () => {}) => {
    const [files, setFiles] = useState([]);

    return {
        files: files,
        setFiles: setFiles,
        FileUpload: <FileUpload files={files} setFiles={setFiles} stepFlowIsEnable={stepFlowIsEnable} deleteJobImage={deleteJobImage}/>,
    };
}

export default FileUploadWrapper;
